module.exports = __webpack_public_path__ + "static/media/logo-vovword.2844f759.jpg";